var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1738896740046,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1888,
    width: 28,
    height: 28,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M952.6 870.8L545.5 122.3c-18.4-34.1-48.6-35.5-67-1.4L71.4 871.6C53 905.6 70 928 109.1 928h805.8c39.1 0 56.1-23.1 37.7-57.2zM512 846.4c-25.9 0-46.9-20.8-46.9-46.3s20.9-46.3 46.9-46.3c25.9 0 46.9 20.8 46.9 46.3s-21 46.3-46.9 46.3z m39.4-199c-5.3 31.7-23 57.7-39.4 57.7-16.3 0-34-26-39.4-57.7l-39.8-241.1c-5.3-31.6 17-63.2 49.5-63.2h59.3c32.6 0 54.9 31.5 49.5 63.2l-39.7 241.1z",
    fill: "#FFA23A",
    "p-id": 1889
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarming);
export default __webpack_public_path__ + "static/media/warming.501496b99f2b6de2e906086c81725108.svg";
export { ForwardRef as ReactComponent };